import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Button } from '../button';
import Modal from '../modal/Modal';

const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  width: 350px;
  text-align: center;
  z-index: 500;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 300px;
  justify-content: space-between;
`;

const Heading = styled.h3`
  margin-top: 0;
`;

const Text = styled.span`
  margin-bottom: 24px;
`;

const RmbalConfirmModal = ({handleConfirm, handleCancel, showModal, currentCollateral}) => {
  const formatKennitala = (kt) => {
    if (!kt || kt.length !== 10) return kt;
    return `${kt.slice(0, 6)}-${kt.slice(6)}`;
  };

  const content = (
    <Container>
      <Heading>
        <FormattedMessage id="Consolidation.GetStatus" />
      </Heading>
      <Text>
        <FormattedMessage 
          id="Consolidation.GetStatus.Description" 
          values={{
            kennitala: formatKennitala(currentCollateral?.operatorId) || <FormattedMessage id="Consolidation.GetStatus.PartyNotFound" />
          }}
        />
      </Text>
      <Row>
        <Button onClick={handleConfirm} content={<FormattedMessage id="Consolidation.GetStatus.Confirm" />} />
        <Button onClick={handleCancel} content={<FormattedMessage id="Consolidation.GetStatus.Cancel" />} />
      </Row>
    </Container>
  );

  return <Modal content={content} showModal={showModal} onClose={handleCancel} ariaHideApp={false} />;
};

RmbalConfirmModal.propTypes = {
  handleConfirm: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  currentCollateral: PropTypes.object,
};

export default RmbalConfirmModal;

